import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, useHistory, Redirect, } from "react-router-dom";
import Configurator from "./Pages/Configurator";
import Login from "./Pages/Login";
import "./App.css";
import Dashboard from "./Pages/Dashboard";
import { useAppDispatch, useAppSelector } from "./hooks/hooks";
import { userConstants } from "./store/actions/types";
import { Toaster } from "react-hot-toast";
import { PrivateRoute } from "./Components/PrivateRoute";
import { Report } from "./Pages/Report";
import Settings from "./Pages/Settings";
import { uuid } from "./utils/uuid";
import ShippingDoc from "./Pages/ShippingDoc";
export default function App() {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const isAuthenticated = useAppSelector((state) => state.user.isAuthenticated);
    useEffect(() => {
        localStorage.setItem("sessionId", uuid());
    }, []);
    useEffect(() => {
        //  check local storage to see if the user has already logged in
        const userData = localStorage.getItem("user");
        const token = localStorage.getItem("token");
        if (userData) {
            const user = JSON.parse(userData);
            if (user) {
                dispatch({
                    type: userConstants.SET_USER,
                    payload: Object.assign(Object.assign({}, user), { token: token }),
                });
            }
        }
    }, [dispatch, history]);
    return (_jsxs(Router, { children: [_jsx(Toaster, { toastOptions: {
                    success: {
                        style: {
                            background: "#a7f3d0",
                            color: "#059669",
                        },
                    },
                    error: {
                        style: {
                            background: "#fecaca",
                            color: "#dc2626",
                        },
                    },
                } }), _jsx("div", { id: "Modal" }), _jsx("div", { id: "QuotationModal" }), _jsx("div", { id: "PricingModal" }), _jsx("div", { id: "ProfileModal" }), _jsxs(Switch, { children: [_jsx(PrivateRoute, Object.assign({ path: "/configurator/:productId" }, { children: _jsx(Configurator, {}) })), _jsx(PrivateRoute, Object.assign({ path: "/configurator" }, { children: _jsx(Configurator, {}) })), _jsx(PrivateRoute, Object.assign({ path: "/dashboard" }, { children: _jsx(Dashboard, {}) })), _jsx(PrivateRoute, Object.assign({ path: "/settings" }, { children: _jsx(Settings, {}) })), _jsx(PrivateRoute, Object.assign({ path: "/report" }, { children: _jsx(Report, {}) })), _jsx(Route, Object.assign({ path: "/login" }, { children: isAuthenticated ? _jsx(Redirect, { to: "/dashboard" }) : _jsx(Login, {}) })), _jsx(Route, Object.assign({ path: "/shipping-doc" }, { children: _jsx(ShippingDoc, {}) })), _jsx(Route, Object.assign({ path: "/" }, { children: isAuthenticated ? _jsx(Redirect, { to: "/dashboard" }) : _jsx(Login, {}) }))] })] }));
}
